import axios from 'axios'
import Vue from 'vue'
import { jsBridge, hasNativeMethod } from './jsBridge'
import { generateUUID } from '../services/stat'
import { getKey, setKey, initGId, isTMDMiniprogram, judgeClientSystem } from './utils'
import settle from 'axios/lib/core/settle'
import router from '../router'
import pkg from '../../package.json'
import { Base64 } from 'js-base64'
import '../components/page-loading'
import CountDownTool from '@/assets/CountDownTool.js'

// 不需要显示indicator的接口
const noIndicatorApi = [
  '/api/index/v1/point',
  '/statistics/api/v1/record/add'
]

// 需要带token但不需要indicator的接口
const noIndicatorWithToken = [
  '/api/credit/v1/queueQuery'
]

// 请求失败不弹回到登录页
const noPopLoginApi = [
  '/api/order/v1/outline',
  '/api/index/v1/credit-limit',
  '/api/user/v1/userBaseInfo'

]

const noToastApi = [
  '/api/idcardocr/tencent/v1/ocr-verify',
  '/merchant/api/loan/v2/h5-contracts',
  '/api/consult/repayment/v1/preview'
  // '/api/loan/v1/amt-product'
]

// 接口通用前缀
const baseURL = '/api'

const vm = new Vue()

const instance = axios.create({
  headers: {
    'content-type': 'application/json;charset=UTF-8'
  }
})

const isAndroid = judgeClientSystem() === 'Android' // android终端
const blApiSend = (parasm) => {
  window.__bl && window.__bl.api(parasm)
}

const _isTMDMiniprogram = isTMDMiniprogram()
const appChannel = getKey('appChannel')
const terminal = _isTMDMiniprogram ? getKey('terminal_jsj') : getKey('terminal') || 'H5'
const channel = _isTMDMiniprogram ? getKey('channel_mp') : appChannel || getKey('channel') || 'official'
const version = _isTMDMiniprogram ? getKey('mpVersion') : getKey('appVersion') || pkg.version
const channelNo = channel

const deviceInfo = {
  terminal: terminal,
  appVersion: version,
  uuid: generateUUID(),
  terminalNew: isAndroid ? 'Android' : 'IOS'
}

let isPageLoading = true

vm.$bus.$on('loading', () => {
  isPageLoading = true
})

vm.$bus.$on('ready', () => {
  isPageLoading = false
})

function shouldIndicator (URL) {
  return !noIndicatorApi.includes(URL) && !isPageLoading
}

function queryStringfy (params) {
  return Object.keys(params).map(key => key + '=' + params[key]).join('&')
}

var gid = ''

initGId().then(id => {
  gid = id
})

instance.interceptors.request.use(async (request) => {
  if (!request.notNeedBaseURL) {
    request.url = baseURL + request.url
  }

  const canIndicator = shouldIndicator(request.url)
  try {
    request.metadata = { startTime: Date.now() } // 计算请求耗时
    
    const commonParams = {
      channelNo: channelNo,
      version: version
    }
    if (request.method === 'post') {
      request.data = Object.assign(commonParams, request.data || {})
    }
    if (request.method === 'get') {
      request.params = Object.assign(commonParams, request.params || {})
    }
    if (!noIndicatorWithToken.includes(request.url)) {
      canIndicator && vm.$indicator()
    }
    if (hasNativeMethod('httpRequest')) {
      request.metadata.nativeHttp = true
      // 如果是hybrid，使用原生方法请求
      const res = await jsBridge('httpRequest', { path: request.method === 'post' ? `${request.url}` : `${request.url}?${queryStringfy(request.params)}`, params: request.method === 'post' ? request.data : request.params, method: request.method.toUpperCase() })
      // 自定义请求响应
      request.adapter = function myAdapter (config) {
        return new Promise(function (resolve, reject) {
          const response = {
            data: res,
            status: 200,
            statusText: request.statusText,
            headers: {},
            config: config,
            request: request
          }
          settle(resolve, reject, response)
        })
      }
      return request
    }
    let device = Base64.encode(JSON.stringify(Object.assign({}, deviceInfo, {
      longitude: getKey('longitude') || '',
      latitude: getKey('latitude') || ''
    })))
    request.headers['X-DEVICE-IF'] = device
    setKey('X-DEVICE-IF', device)
    if (!noIndicatorApi.includes(request.url)) {
      request.headers['X-TOKEN'] = getKey('userInfo', 'token') || ''
    }
    request.headers['channelNo'] = channel
    request.headers['gid'] = gid
    request.timeout = 60 * 1000
    return request
  } catch (exp) {
    canIndicator && vm.$indicator.close()
  }
})
instance.interceptors.response.use((response) => {
  // 对响应数据做点什么
  const canIndicator = shouldIndicator(response.config.url)
  canIndicator && vm.$indicator.close()
  const data = response.data
 

  if (data.code === 'TMD777' && hasNativeMethod('updateApp')) {
    jsBridge('updateApp', { message: data.msg })
  }
  if (data.code === '000005') {
    // 清除用户信息
    setKey('userInfo', {
      token: '',
      mobile: '',
      wu: '',
      name: ''
    })
    localStorage.removeItem('IRR24')
    localStorage.removeItem('channel')
    localStorage.removeItem(CountDownTool.Keys.HomeCountDownEndTime)
    localStorage.removeItem(CountDownTool.Keys.PassCardCountDownTimeStamp)
    if (hasNativeMethod('loginOut')) {
      jsBridge('loginOut')
    }
  }
  // 风控接口
  if (data.code === 'OK') return response
  if (data.code !== '000000' && !noPopLoginApi.includes(response.config.url)) {
    // 请求未成功
    if (data.code === '000005') {
      vm.$message(data.msg)
      if (['API-XHQB', 'API-WEIBO'].includes(getKey('channel'))) {
        window.location.href = getKey('successUrl')
      } else {
        /**
         * 未登录
         * 存储当前页面，跳转到登录页面后，跳转到当前页面
         */
        if (window.location.href.indexOf('/user/login') < 0) {
          sessionStorage.setItem('storeUrl', window.location.href)
        }
        if (hasNativeMethod('navigateTo')) {
          jsBridge('navigateTo', { path: 'login', exitCurrent: true })
        } else {
          router.replace('/user/login')
        }
      }
    } else {
      if (data.code === '100002' || data.code === '000010' || data.code === '000028' || noToastApi.includes(response.config.url)) { // 验证码错误
        // DO NOTHING
      } else {
        if (!response?.config?.metadata?.nativeHttp) {
          response.config.metadata.endTime = Date.now()
          const duration = response.config.metadata.endTime - response.config.metadata.startTime // 请求时长
          blApiSend({ api: response.config.url, success: false, code: data.code, msg: data.msg, time: duration })
        }
      
        vm.$message(data.msg, data.msg && data.msg.length > 12 ? 2000 : 1000)
      }
    }
    return response
  } else {
    return response
  }
}, (error) => {
  const response = error.response
  const { path } = response?.data || {}
  if (!response?.config?.metadata?.nativeHttp) {
    response.config.metadata.endTime = Date.now()
    const duration = response.config.metadata.endTime - response.config.metadata.startTime // 请求时长
    blApiSend({ api: path, success: false, code: response.status, msg: response.statusText, time: duration })
  }
  // 对响应错误做点什么
  vm.$indicator.close(true)
  return Promise.reject(error)
})

export default instance
